<div class="list-tab-block">
    <!-- <p class="text-14-400 color-8 mb-0 ri-py-2 ri-px-4 text-center bg-26">{{ ss.t('trash_itemEraseContent') }}</p> -->
    <div class="list-trash-block ri-px-4 ri-pt-4 ri-bb-1 entity-block" *ngFor="let entity of deletedLists(); let i = index; trackBy: trackByEntity;">
        <app-list-block [listId]="entity.entityId" [show]="show"></app-list-block>
        <div class="flex items-center justify-around ri-pt-1">
            <button class="btn-text text-16-400 color-11 ri-px-8 ri-py-4" (click)="remove(entity.entityId)">{{
                ss.t('common_buttonRemove') }}</button>
            <button class="btn-text text-14-400 color-35 ri-px-8 ri-py-4" (click)="restore(entity.entityId)">{{
                ss.t('common_restore') }}</button>
        </div>
    </div>

    <div class="no-result-block h-full flex items-center justify-center flex-col" *ngIf="deletedLists().length === 0">
        <app-svg [name]="'listPlaceholder'" [color]="ss.theme().color1"></app-svg>
        <p class="text-16-400 color-8 mb-0 ri-pt-4">{{ ss.t('listsMyLists_emptyScreenContent') }}</p>
    </div>
</div>